import styled from 'styled-components';

export const CommandSuggestionsContainer = styled.div`
  position: absolute;
  bottom: 100%;
  left: 0;
  right: 0;
  background: ${({ theme }) => theme.colorPalette.white};
  border: 1px solid ${({ theme }) => theme.colorPalette.grey.grey3};
  z-index: 1000;
  max-height: 232px;
  overflow-y: auto;
`;

export const CommandDescription = styled.div`
  font-size: 14px;
  color: ${({ theme }) =>
    theme.colorPalette.isDarkMode ? theme.colorPalette.grey.grey8 : theme.colorPalette.grey.grey6};
`;

export const CommandSuggestionItem = styled.div<{ isActive: boolean }>`
  padding: 14px 20px;
  cursor: pointer;
  border-bottom: 1px solid ${({ theme }) => theme.colorPalette.grey.grey3};
  transition: all 0.15s ease;

  background-color: ${({ theme, isActive }) =>
    isActive
      ? theme.colorPalette.isDarkMode
        ? theme.colorPalette.turquoise.dark
        : theme.colorPalette.turquoise.accent2
      : 'transparent'};

  &:last-child {
    border-bottom: none;
  }
`;

export const CommandFormat = styled.div`
  font-size: 16px;
  color: ${({ theme }) => theme.colorPalette.grey.grey8};
  margin-bottom: 4px;
  font-weight: 500;
`;
